import type {EndpointDirectoryV3} from '@smart/endpoint-directory';
import type {IAPIResponseData} from '../../bff/post-form/mulesoft/types';
import {useToken} from '../hooks/use-token';

export async function postFormToEndpoint(
  baseUrl: string = ``,
  endpointDirectory: EndpointDirectoryV3,
  options: Record<string, string>,
  body: Object,
  abortSignal: AbortSignal,
): Promise<IAPIResponseData> {
  const {sessionToken, setToken} = useToken();
  const {envName, preview, rotatingVerifySecret} = endpointDirectory;

  const searchParams = new URLSearchParams({
    envName,
    preview: String(preview),
    ...options,
  });

  if (rotatingVerifySecret) {
    const {headerName, headerValue} = rotatingVerifySecret;
    searchParams.set(`rotatingVerifySecret`, `${headerName}:${headerValue}`);
  }
  const url = `${baseUrl}/bff/post-form?${searchParams.toString()}`;
  const response = await fetch(url, {
    body: JSON.stringify({
      sessionToken: sessionToken || undefined,
      ...body,
    }),
    method: `POST`,
    signal: abortSignal,
  });

  if (!response.ok) throw await response.text();

  const responseJSON = (await response.json()) as IAPIResponseData;

  // saves token if it exists in response
  if (responseJSON.token) setToken(responseJSON.token);

  return responseJSON;
}
